'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/pagination/style/css');

var _pagination = require('antd/lib/pagination');

var _pagination2 = _interopRequireDefault(_pagination);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _media = require('../actions/media');

var _with_upload_sign = require('../hocs/with_upload_sign');

var _with_upload_sign2 = _interopRequireDefault(_with_upload_sign);

var _media_list = require('../components/media_list');

var _media_list2 = _interopRequireDefault(_media_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Media = _react2.default.createClass({
    displayName: 'Media',

    propTypes: {
        media: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (nextProps.media.didInvalidate) {
            this.props.dispatch((0, _media.fetchMediaIfNeeded)());
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _media.fetchMediaIfNeeded)(filter));
    },
    onChange: function onChange(page, pageSize) {
        this.props.dispatch((0, _media.fetchMediaIfNeeded)({
            page: page
        }));
    },
    handleClickUpload: function handleClickUpload() {
        this.refs['input-file'].click();
    },
    handleSelectFiles: function handleSelectFiles(event) {
        var files = event.target.files;
        this.props.dispatch((0, _media.postMediaIfNeeded)(files, this.props.uploadSign));
    },
    render: function render() {
        var pagination = this.props.media.pagination;

        return _react2.default.createElement(
            'div',
            { id: 'media', className: 'clearfix' },
            _react2.default.createElement(
                _button2.default,
                { type: 'primary', id: 'btn-upload', onClick: this.handleClickUpload },
                '\u4E0A\u4F20\u56FE\u7247'
            ),
            _react2.default.createElement('input', { ref: 'input-file', type: 'file', multiple: true, accept: 'image/*', className: 'hidden', onChange: this.handleSelectFiles }),
            _react2.default.createElement(_media_list2.default, { media: this.props.media, onSelect: this.props.onSelect, selectedMedia: this.props.selectedMedia }),
            _react2.default.createElement(_pagination2.default, { defaultCurrent: 1, defaultPageSize: pagination.per_page, total: pagination.total, onChange: this.onChange })
        );
    }
}); /**
     * 媒体库页面，可用于单独查看媒体库，也可用于在产品编辑表单中弹出后选择详情图片
     */


var mapStateToProps = function mapStateToProps(store) {
    var _store$media = store.media,
        media = _store$media.media,
        filter = _store$media.filter;
    var uploadSign = store.uploadSign;

    return {
        media: media,
        filter: filter,
        uploadSign: uploadSign
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _with_upload_sign2.default)(Media, true));


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/media.js
// module id = 1469
// module chunks = 0